import { OnInit, Component, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-MaturityScheduleWrapper',
    templateUrl: './MaturityScheduleWrapper.component.html'
})
export class MaturityScheduleWrapper implements OnInit {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: string = 'b5c7aed7cd2a308523e7d2847b7815909e864b2fd9c4ea88b00d35adb2ecdfd7';
    themeType: string;
    constructor(private contextService: IContextService, @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.themeType = 'ada';
        }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
        });
    }
}
